import { render, staticRenderFns } from "./CategoriesFilterDesktop.vue?vue&type=template&id=7f1c2d6c&scoped=true&"
import script from "./CategoriesFilterDesktop.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilterDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilterDesktop.vue?vue&type=style&index=0&id=7f1c2d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c2d6c",
  null
  
)

export default component.exports